export default __webpack_public_path__ + "static/media/oct2023-5.247a9cb5.jpeg";